import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { serverUrl, client } from "../../config";
import GridItem from "../../partials/gridItem";

export default function VideoItem(props) {
  const navigate = useNavigate();
  const [actionsAnchor, setActionsAnchor] = useState(null);

  let path =
    client === "equans"
      ? `${serverUrl}/${props.item.field_featured_image}`
      : `${serverUrl}/api/video/thumbnail?mid=${props.item?.mid}`;

  if (props.item.field_media_oembed_video) {
    path = `${serverUrl}/${props.item.thumbnail}`;
  }

  return (
    <>
      <GridItem
        xs={12}
        sm={6}
        md={3}
        itemClass="video"
        item={props.item}
        bundle={props.item?.bundle}
        id={props.item?.nid}
        title={props.item?.title}
        field_body={props.item?.summary || props.item?.body}
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={path}
        alt={`Poster for Video ${props.item.nid}`}
        cardActionArea={true}
        creator={props.creator}
        cardActionCallBack={
          props.creator ? () => {} : () => navigate(`/videos/${props.item?.nid}`)
        }
        contentType={props.contentType}
        shareEnabled
        route={"videos"}
        field_access_token={props.item.access_token}
        sharePrompt={`This is a public link that enables you to share the video with your client, no login required.`}
      ></GridItem>
    </>
  );
}
